import {
  CheckCircleFilled,
  CloseCircleFilled,
  CloseOutlined,
} from '@ant-design/icons';
import { Button, Input } from '@mm/components';
import { useConnectedPageCRUDActions } from '@mm/state/actions/ConnectedPageCRUDActions';
import { useSubscriptionCRUDActions } from '@mm/state/actions/SubscriptionCRUDActions';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import classNames from 'classnames';
import React, { useState } from 'react';
import styles from './AddPromocodeModal.module.css';

export const AddPromocodeModal = ({
  defaultPromocode,
  facebookPageId,
  companyId,
}: {
  facebookPageId: number;
  companyId: number;
  defaultPromocode?: string;
}) => {
  const { closeModal } = useModalActions();
  const { reedemPromocode } = useSubscriptionCRUDActions();
  const { retrieveBasicListByCompany } = useConnectedPageCRUDActions();
  const [promocode, setPromocode] = useState(defaultPromocode || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const confirmDisabled =
    !promocode.trim() ||
    promocode.length < 3 ||
    defaultPromocode === promocode ||
    busy ||
    error;

  const onConfirm = async () => {
    try {
      setBusy(true);
      await reedemPromocode(promocode, facebookPageId);
      await retrieveBasicListByCompany(companyId, {
        withSubscription: true,
        withDowngradePending: true,
        withMessagesStatistic: true,
      });
      closeModal();
    } catch (e) {
      setError(e);
    } finally {
      setBusy(false);
    }
  };

  const onInputChange = (value: string) => {
    const invalidChars = /[.,/]/g;
    const v = value.replace(invalidChars, '');
    setPromocode(v);
    setError(false);
  };

  return (
    <div className={styles.container}>
      <CloseOutlined
        className={styles.closeIcon}
        onClick={() => closeModal()}
      />
      <div className={styles.header}>
        <div className={styles.title}>Add Promocode</div>
      </div>

      {defaultPromocode && (
        <>
          <div className={styles.promocodeBox}>
            <CheckCircleFilled className={styles.successIcon} />
            Discount applied: {defaultPromocode}
          </div>

          <Button
            css={{
              container: classNames(styles.cancelButton, styles.centered),
            }}
            color="transparent-no-shadow"
            onClick={() => closeModal()}
          >
            Close
          </Button>
        </>
      )}
      {!defaultPromocode && (
        <>
          <div className={styles.inputContainer}>
            <div className={styles.titleSmall}>Promocode</div>
            <Input
              css={{
                container: styles.inputWrapper,
              }}
              value={promocode}
              onChange={e => {
                onInputChange(e.target.value);
                setError(false);
              }}
              invalid={error && !busy}
              isLoading={busy}
              placeholder="Enter promocode"
            />
            {error && !busy && (
              <div className={styles.error}>
                <CloseCircleFilled className={styles.errorIcon} />
                This coupon is not valid
              </div>
            )}
          </div>
          <div className={styles.buttons}>
            <Button
              css={{ container: styles.cancelButton }}
              color="transparent-no-shadow"
              onClick={() => closeModal()}
            >
              Cancel
            </Button>
            <Button
              css={{ container: styles.button }}
              onClick={onConfirm}
              disabled={confirmDisabled}
            >
              Apply
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
